/**
 * Name shown on an AnonNameCardMorph contact card.
 *
 * The SENT (own) card always uses its own bubble's name. On a converted
 * guest's carried-over conversation the anon-name card is THEIRS, so labelling
 * it with the peer-derived `anonContactCardName` showed the other person's name
 * (display-bugs §3 — "Harry's own card → Mark Mangan", 2026-10-05). Mark's
 * ruling: the own card shows the shared name (the bubble's own name), matching
 * what the host sees.
 *
 * The RECEIVED card keeps the peer's record name, falling back to the bubble's
 * own name so the card never renders empty if the record's name lands late.
 *
 * @param {{ sent: boolean, anonContactCardName: (string|null), anonName: string }} args
 * @returns {string}
 */
export const anonCardName = ({ sent, anonContactCardName, anonName }) =>
  sent ? anonName : anonContactCardName || anonName;
